import axios from "axios";
import { useAuthStore } from "~/store/auth";

export default function useAxiosInstance() {
  const { token } = useAuthStore()
  const config = useRuntimeConfig()
  const options = {
    baseURL: config.public.baseAPI
  }

  if (token) {
    options.headers = {
      common: {
        Authorization: `Bearer ${token}`
      }
    }
  }

  return axios.create(options)
}
